<template>
  <div>
    <Header />

    <div v-if="isLoaded">
      <div id="model-header">
        <h1 id="model-title">{{ modelTitle }}</h1>
        <h2 id="model-subtitle">{{ modelDescription }}</h2>
      </div>

      <div id="example-dag">
        <ModelDAGVisualization
          v-if="isLoaded"
          :graphWidth="850"
          :graphHeight="475"
          :staticColoring="true"
        />
      </div>

      <VButton @click="initializeNewModel">Create New Model</VButton>
    </div>
    <div v-else>
      <p>We haven't added modeling for <b>{{ templateName }}</b> yet,
        but we're expanding quickly.</p>
        
      <p>Please contact us if you'd like this template added!</p>
    </div>

    <hr />

    <EmailCollection />

    <Footer />
  </div>
</template>

<script>
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';
import EmailCollection from '@/components/layout/EmailCollection';
import ModelDAGVisualization from '@/components/model/ModelDAGVisualization';

import { mapActions, mapState, mapMutations } from 'vuex';
import VButton from '../components/ui/VButton.vue';

const d3 = require('d3');
const d3arr = require('d3-array');
const axios = require('axios');

export default {
  name: 'Stock',
  components: {
    Header,
    Footer,
    ModelDAGVisualization,
    EmailCollection,
    VButton
  },
  props: {
    templateName: String
  },
  mounted() {
    let prototype;
    if (this.templateName === 'AAPL') {
      import('@/js/model/templates/AAPL.js').then((module) => {
        prototype = module.template
        this.setState(prototype);
      });
    } else if (this.templateName === 'AutoLoan') {
      import('@/js/model/templates/AutoLoan.js').then((module) => {
        prototype = module.template
        this.setState(prototype);
      });
    }
  },
  computed: {
    ...mapState(['modelID','modelTitle','modelDescription','isLoaded'])
  },
  methods: {
    ...mapMutations(['setState']),
    ...mapActions(['saveModel']),
    initializeNewModel() {
      this.saveModel().then(
        (modelID) => {
          this.$router.push({'name': 'Model View', 'params': {'modelID': modelID}});
        });
    }
  }
}
</script>

<style scoped>
#example-dag {
  margin-left: auto;
  margin-right: auto;
  max-width: 90%;
}

/* Model Header */
#model-header {
  margin-top: 20px;
}
#model-header > * {
  margin: 0px;
  width: 50%;
  margin-left: auto;
  margin-right: auto;
}
#model-title {
  font-size: 1.3em;
}
#model-subtitle {
  font-size: 1em;
  font-weight: normal;
}
.model-id-text {
  color: gray;
  font-size: .8em;
}
</style>